import { GA_TRACKING_ID } from '@/lib/gtag';
import { useLocale, useTranslations } from 'next-intl';
import { JSX, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import './Footer.scss';

const Footer = (): JSX.Element => {
  const t = useTranslations();
  const locale = useLocale();
  useEffect(() => {
    TagManager.initialize({
      gtmId: GA_TRACKING_ID
    });
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagePath: 'page-path-here',
        pageTitle: 'page-title-here'
      }
    });
  });
  return (
    <footer>
      <div className="footer">
        <div className="top">
          <a
            className="logo"
            target="_blank"
            href={`https://www.aswatson.com/${locale != 'en' ? locale : ''}`}
          >
            <img
              alt="img"
              src={`/img/smile/ASW LOGO_PRIMARY_HORIZONTAL_WHITE.png`}
            />
          </a>
          <div className="media">
            <a
              target="_blank"
              href="https://www.facebook.com/ASWGroupofficial/"
            >
              <img alt="img" src={`/img/smile/facebook.svg`} />
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/aswatsongroup_corp/"
            >
              <img alt="img" src={`/img/smile/intagram.svg`} />
            </a>
            <a
              target="_blank"
              href="https://www.linkedin.com/company/aswatson/"
            >
              <img alt="img" src={`/img/smile/linkin.svg`} />
            </a>
          </div>
        </div>
        <div className="bottom">
          <a target="_blank" href={t.raw('Smile.footer.copyright.url')}>
            {t.raw('Smile.footer.copyright.name')}
          </a>
          <a target="_blank" href={t.raw('Smile.footer.disclaimer.url')}>
            {t.raw('Smile.footer.disclaimer.name')}
          </a>
          <button className="ot-sdk-show-settings">
            {t.raw('Smile.footer.cookie.name')}
          </button>
          <a target="_blank" href={t.raw('Smile.footer.accessibility.url')}>
            {t.raw('Smile.footer.accessibility.name')}
          </a>
          <a href={t.raw('Smile.footer.tnc.url')}>
            {t.raw('Smile.footer.tnc.name')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
